export default {
    name: "Dashboard",
    data() {
        return {
            activeTab: 'principal',
            tabs: [
                { id: 'principal', value: 'Principal', active: true },
                { id: 'uso', value: 'Uso', active: false },
                { id: 'churn', value: 'Churn', active: false },
                { id: 'financeiro', value: 'Financeiro', active: false },
            ],
            // Loading states
            loadingGeneral: false,
            loadingUsage: false,
            loadingChurn: false,
            loadingFinances: false,
            // General tab data
            generalData: null,
            monthlySignupsChart: { labels: [], values: [] },
            professionalTypeChart: { labels: [], datasets: [] },
            subscribersTypeChart: { labels: [], values: [] },
            gatewayChart: { labels: [], datasets: [] },
            // Usage tab data
            usageData: null,
            recipeTypeChart: { labels: [], values: [] },
            monthlyRecipesChart: { labels: [], values: [] },
            doctorUsageChart: { labels: [], values: [] },
            // Churn tab data
            churnData: null,
            stripeChurnChart: { labels: [], churnPercent: [], activeBase: [], newSubscriptions: [], cancellations: [], netGrowth: [] },
            inappChurnChart: { labels: [], churnPercent: [], activeBase: [], newSubscriptions: [], cancellations: [], netGrowth: [] },
            churnCohortChart: { labels: [], values: [] },
            inappChurnCohortChart: { labels: [], values: [] },
            // Finances tab data
            financesData: null,
            stripeMrrChart: { labels: [], values: [] },
            inappMrrChart: { labels: [], values: [] },
            totalMrrChart: { labels: [], values: [] },
            stripeRevenueChart: { labels: [], values: [] },
            inappRevenueChart: { labels: [], values: [] },
            totalRevenueChart: { labels: [], values: [] },
        }
    },
    mounted() {
        this.loadGeneralData();
    },
    methods: {
        handleTabClicked(id) {
            this.activeTab = id;
            this.tabs = this.tabs.map(tab => ({
                ...tab,
                active: tab.id === id
            }));

            // Load data for the selected tab if not already loaded
            if (id === 'uso' && !this.usageData) {
                this.loadUsageData();
            }
            if (id === 'churn' && !this.churnData) {
                this.loadChurnData();
            }
            if (id === 'financeiro' && !this.financesData) {
                this.loadFinancesData();
            }
        },
        forceRefreshCurrentTab() {
            const loaders = {
                principal: () => this.loadGeneralData(true),
                uso: () => this.loadUsageData(true),
                churn: () => this.loadChurnData(true),
                financeiro: () => this.loadFinancesData(true),
            };
            if (loaders[this.activeTab]) {
                loaders[this.activeTab]();
            }
        },
        async loadGeneralData(forceRefresh = false) {
            this.loadingGeneral = true;
            try {
                const params = forceRefresh ? { forceRefresh: true } : {};
                const res = await this.$userService.dashboardGeneral(params);
                this.generalData = res.data;
                this.processChartData();
            } catch (error) {
                console.log('Erro ao carregar dashboard', error);
            } finally {
                this.loadingGeneral = false;
            }
        },
        async loadUsageData(forceRefresh = false) {
            this.loadingUsage = true;
            try {
                const params = forceRefresh ? { forceRefresh: true } : {};
                const res = await this.$userService.dashboardUsage(params);
                this.usageData = res.data;
                this.processUsageChartData();
            } catch (error) {
                console.log('Erro ao carregar dados de uso', error);
            } finally {
                this.loadingUsage = false;
            }
        },
        async loadChurnData(forceRefresh = false) {
            this.loadingChurn = true;
            try {
                const params = forceRefresh ? { forceRefresh: true } : {};
                const res = await this.$userService.dashboardChurn(params);
                this.churnData = res.data;
                this.processChurnChartData();
            } catch (error) {
                console.log('Erro ao carregar dados de churn', error);
            } finally {
                this.loadingChurn = false;
            }
        },
        async loadFinancesData(forceRefresh = false) {
            this.loadingFinances = true;
            try {
                const params = forceRefresh ? { forceRefresh: true } : {};
                const res = await this.$userService.dashboardFinances(params);
                this.financesData = res.data;
                this.processFinancesChartData();
            } catch (error) {
                console.log('Erro ao carregar dados financeiros', error);
            } finally {
                this.loadingFinances = false;
            }
        },
        processChartData() {
            if (!this.generalData) return;

            // Monthly signups chart
            if (this.generalData.monthly_signups) {
                this.monthlySignupsChart = {
                    labels: this.generalData.monthly_signups.map(item => item.month),
                    values: this.generalData.monthly_signups.map(item => item.count),
                };
            }

            // Professional type chart (stacked bar)
            if (this.generalData.signups_by_professional_type) {
                const data = this.generalData.signups_by_professional_type;
                const colors = {
                    doctor: '#2e4664',
                    student: '#4a7c59',
                    dentist: '#f4a261',
                    other: '#e76f51',
                };
                const labels = {
                    doctor: 'Médicos',
                    student: 'Estudantes',
                    dentist: 'Dentistas',
                    other: 'Outros',
                };
                this.professionalTypeChart = {
                    labels: data.map(item => item.month),
                    datasets: ['doctor', 'student', 'dentist', 'other'].map(type => ({
                        label: labels[type],
                        data: data.map(item => item[type] || 0),
                        backgroundColor: colors[type],
                    })),
                };
            }

            // Subscribers by type chart (pie)
            if (this.generalData.subscribers_by_type) {
                this.subscribersTypeChart = {
                    labels: this.generalData.subscribers_by_type.map(item => item.type),
                    values: this.generalData.subscribers_by_type.map(item => item.count),
                };
            }

            // Gateway chart (stacked bar)
            if (this.generalData.monthly_subscriptions_by_gateway) {
                const data = this.generalData.monthly_subscriptions_by_gateway;
                this.gatewayChart = {
                    labels: data.map(item => item.month),
                    datasets: [
                        {
                            label: 'Stripe',
                            data: data.map(item => item.stripe || 0),
                            backgroundColor: '#2e4664',
                        },
                        {
                            label: 'In-App Purchase',
                            data: data.map(item => item.iap || 0),
                            backgroundColor: '#4a7c59',
                        },
                    ],
                };
            }
        },
        processUsageChartData() {
            if (!this.usageData) return;

            // Recipe type chart (pie)
            if (this.usageData.recipe_count_by_type) {
                const typeLabels = {
                    'exam request': 'Pedido de Exame',
                    'simple': 'Simples',
                    'special control': 'Controle Especial',
                    'sick note': 'Atestado',
                    'free text': 'Texto Livre',
                };
                const data = this.usageData.recipe_count_by_type;
                this.recipeTypeChart = {
                    labels: Object.keys(data).map(key => typeLabels[key] || key),
                    values: Object.values(data),
                };
            }

            // Monthly recipes chart (bar)
            if (this.usageData.monthly_recipes) {
                this.monthlyRecipesChart = {
                    labels: this.usageData.monthly_recipes.map(item => item.month),
                    values: this.usageData.monthly_recipes.map(item => item.count),
                };
            }

            // Doctor usage chart (pie)
            if (this.usageData.doctor_subscriber_usage_type) {
                const usageLabels = {
                    'somente_receitas': 'Somente Receitas',
                    'somente_prontuarios': 'Somente Prontuários',
                    'sem_atividade': 'Sem Atividade',
                    'ambas_atividades': 'Ambas Atividades',
                };
                const data = this.usageData.doctor_subscriber_usage_type;
                this.doctorUsageChart = {
                    labels: Object.keys(usageLabels).map(key => usageLabels[key]),
                    values: Object.keys(usageLabels).map(key => data[key] || 0),
                };
            }
        },
        buildChurnChartData(items) {
            return {
                labels: items.map(item => item.year_month),
                churnPercent: items.map(item => item.churn_percent || 0),
                activeBase: items.map(item => item.active_base || 0),
                newSubscriptions: items.map(item => item.new_subscriptions || 0),
                cancellations: items.map(item => item.cancellations || 0),
                netGrowth: items.map(item => item.net_growth || 0),
            };
        },
        processChurnChartData() {
            if (!this.churnData) return;

            // Stripe churn chart
            if (this.churnData.stripe_churn) {
                this.stripeChurnChart = this.buildChurnChartData(this.churnData.stripe_churn);
            }

            // In-App churn chart
            if (this.churnData.inapp_churn) {
                this.inappChurnChart = this.buildChurnChartData(this.churnData.inapp_churn);
            }

            // Churn cohort chart (bar) - tempo até cancelar
            if (this.churnData.stripe_churn_cohort) {
                const data = this.churnData.stripe_churn_cohort;
                this.churnCohortChart = {
                    labels: data.map(item => `${item.months_active} ${item.months_active === 1 ? 'mês' : 'meses'}`),
                    values: data.map(item => item.count),
                };
            }

            // In-App churn cohort chart (bar)
            if (this.churnData.inapp_churn_cohort) {
                const data = this.churnData.inapp_churn_cohort;
                this.inappChurnCohortChart = {
                    labels: data.map(item => `${item.months_active} ${item.months_active === 1 ? 'mês' : 'meses'}`),
                    values: data.map(item => item.count),
                };
            }
        },
        processFinancesChartData() {
            if (!this.financesData) return;

            if (this.financesData.stripe_mrr) {
                this.stripeMrrChart = {
                    labels: this.financesData.stripe_mrr.map(item => item.year_month),
                    values: this.financesData.stripe_mrr.map(item => item.mrr),
                };
            }

            if (this.financesData.inapp_mrr) {
                this.inappMrrChart = {
                    labels: this.financesData.inapp_mrr.map(item => item.year_month),
                    values: this.financesData.inapp_mrr.map(item => item.mrr),
                };
            }

            if (this.financesData.total_mrr) {
                this.totalMrrChart = {
                    labels: this.financesData.total_mrr.map(item => item.year_month),
                    values: this.financesData.total_mrr.map(item => item.mrr),
                };
            }

            if (this.financesData.stripe_revenue) {
                this.stripeRevenueChart = {
                    labels: this.financesData.stripe_revenue.map(item => item.year_month),
                    values: this.financesData.stripe_revenue.map(item => item.revenue),
                };
            }

            if (this.financesData.inapp_revenue) {
                this.inappRevenueChart = {
                    labels: this.financesData.inapp_revenue.map(item => item.year_month),
                    values: this.financesData.inapp_revenue.map(item => item.revenue),
                };
            }

            if (this.financesData.total_revenue) {
                this.totalRevenueChart = {
                    labels: this.financesData.total_revenue.map(item => item.year_month),
                    values: this.financesData.total_revenue.map(item => item.revenue),
                };
            }
        },
    }
};
